<template lang="html">
  <div>
    <div id="hideImg">
        <div class="share-container" id="shareImg">
          <div class="bg">
            <img src="~mobile/pic/shareWx/logo_w.png" class="logo"/>
            <div class="content-bg">
              <div class="content">
                <div class="title" v-if="table_detail.type == 0">{{table_detail.hide_title == 0 ? table_detail.title : theme_info.title}}</div>
                <div class="top-title" v-else>
                  <div class="font">{{table_detail.hide_title == 0 ? table_detail.title : theme_info.title}}</div>
                </div>
                <div class="summary" v-html="table_detail.summary"></div>
                <div class="table">
                  <Table :columns="listColumns" :data="listData" :class="{'toplist': table_detail.type == 1}"></Table>
                </div>
              </div>
            </div>
            <div class="content-footer">数据来源：动脉橙数据库</div>
            <div class="footer">
              <img :src="xcx_code" />
              <p>进入小程序，查看更多详情</p>
            </div>
          </div>
        </div>
    </div>
    <div id="showImg">
      <img :src="imgbase" />
    </div>
    <div class="loading_img" v-if="loading">
      <div class="con"><span class="loader-box"></span><br><p>图片生成中</p></div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { share } from 'mobile/js/wx_share'
import { getTableById, wxShare, getdgxcxcode } from '../service'
import moment from 'moment'

export default {
  data() {
    return {
      loading: true,
      imgbase: '',
      xcx_code: '',
      listColumns: [],
      listData: [],
      table_detail: '',
      theme_info: '',
      loading1: false,
      loading2: false
    }
  },
  computed: {
    getLoading() {
      return this.loading1 && this.loading2
    }
  },
  methods: {
    async getTableById() {
      let params = {
        table_id: this.$route.query.table_id,
        theme_uid: this.$route.query.theme_uid,
      }
      let res = await getTableById(params, (error) => {this.$Message.error('请求错误！')})
      
      this.loading1 = true
      if (res.status == 'success') {
        this.$set(this.$data, 'table_detail', res.res[0])
        this.$set(this.$data, 'theme_info', res.theme_info[0])
        let table_wid
        
        if (this.table_detail.content.length) {

          let tarr = this.table_detail.content[0].table_content.filter((b) => b.meta == '序号')

          if (tarr.length || this.table_detail.type == 1) {
            if (tarr.length == 0) {
              table_wid = 540
              this.listColumns.push({
                title: '排名',
                width: 59,
                align: 'center',
                className: 'num',
                render: (h, params) => {
                  let cls = ['dec-num', 'dec-num-' + (params.index + 1)]
                  return h('div', { class: cls }, params.index + 1)
                },
              })
            } else {
              table_wid = 599 - 59 * tarr.length
            }
          } else {
            table_wid = 599
          }

          this.table_detail.content.map((a,index) => {
            let obj = {}
            let wid = 0
            if(index === 0) {
              a.table_content.map((b) => {
                if (b.meta !== '序号') wid += b.col_width
              })
            }
            a.table_content.map((b, e_id) => {
              obj['content_name' + e_id] = b.element_value
              if(index === 0 ) {
                if (b.meta === '序号') {
                  this.listColumns.push({
                    title: b.element_name,
                    width: 59,
                    className: 'num',
                    align: 'center',
                    render: (h, params) => {
                      let cls = ['dec-num', 'dec-num-' + params['row']['content_name' + e_id]]
                      return h('div', { class: cls }, params['row']['content_name' + e_id])
                    }
                  })
                } else {
                  this.listColumns.push({
                    title: b.element_name,
                    key: 'content_name' + e_id,
                    width: b.col_width/wid*table_wid,
                  })
                }
              }
            })
            this.listData.push(obj)
          })
          console.log(this.listColumns)
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    handleCreateImage() {
      html2canvas(document.getElementById('shareImg'),{ scale: 1, useCORS: true, tainttest: true}).then((canvas) => {
        let save_url= canvas.toDataURL("image/png")
        this.$set(this.$data, 'imgbase', save_url)
        this.loading = false
      })
    },
    async themeShare() {
      let res = await wxShare({"url":this.$store.state.req_url+"/mindex" + this.$route.fullPath},
        (error) => { this.$Message.error('请求错误!') }
      )
      share(res, {
        title: this.table_detail.title,
        desc: this.table_detail.unsign_summary,
        link: this.$store.state.req_url + '/mindex' + this.$route.fullPath,
        imgUrl: this.$store.state.req_url+'/share_pro.png'
      }, this, window.location.href)
    },
    async getXcxCode() {
      let res = await getdgxcxcode({
        page: 'pages/themeDetail/themeDetail',
        scene: this.$route.query.theme_uid
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.xcx_code = 'data:image/png;base64,' + res.info
        this.$nextTick(() => {this.loading2 = true})
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  created() {
    this.getTableById()
  },
  mounted() {
    this.themeShare()
    this.getXcxCode()
  },
  watch: {
    getLoading(val) {
      if(val) this.handleCreateImage()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~mobile/styles/shareLoading.stylus'
@import '~mobile/styles/shareWx.stylus'
#hideImg
  overflow: hidden
  height: 0
  width: 0
.top-title
  display flex
  justify-content center
  background url('~pic/topfontbg.png') top center no-repeat
  background-size auto 58px
  .font
    font-size 38px
    line-height 1.2
    padding 30px 90px 0
    color #404877
    position relative
    text-align center
    &:before, &:after
      content ''
      position absolute
      width 74px
      height 14px
      background url('~pic/topfontlt.png') center no-repeat
      background-size 100% 100%
      top 44px
      left 0
    &:after
      left auto
      right 0
      background url('~pic/topfontrt.png') center no-repeat
      background-size 100% 100%
.table
  position: relative
  margin-top: 20px
  >>> .ivu-table-wrapper
    border: 0
    .ivu-table
      background-color: transparent
      background-image: url('~pic/watermark-gray.png');
      &:before
      &:after
        content: none
      td
      th
        border-bottom: 0
        background-color: transparent
        border-left: 1px solid #eee
      .ivu-table-header
        background:  #ffa961
        th
          color: #FFFFFF
          font-size: 12px
          font-weight: normal
          height: 48px
          &.num
            .ivu-table-cell
              padding: 0
      .ivu-table-body
        tr
          td:nth-of-type(1)
            border-left: 0
        .ivu-table-row:nth-of-type(even)
          background: rgba(255,136,36,.2)
          td.num .ivu-table-cell .dec-num
            color: #fff
        td
          color: #333
          padding: 16px 0
          &.num
            .ivu-table-cell
              padding: 0
              text-align: center
              .dec-num
                text-align: center
                font-size: 18px
                font-weight: bold
                color: #ffcda3
      .ivu-table-cell
        padding-left: 5px
        padding-right: 5px
        font-size: 0
        span
          display: block
          word-break: break-all
          font-size: 12px
          line-height: 18px
      tr
        td:first-of-type
        th:first-of-type
          .ivu-table-cell
            padding-left: 10px
        td:last-of-type
        th:last-of-type
          .ivu-table-cell
            padding-right: 10px
  .toplist
    >>> .ivu-table
      table
        border 0
      .ivu-table-header
        background: linear-gradient(0deg, #3D4575 0%, #292D4D 100%)
      th
        border 0
        color #fff
      td
        border 0
        .dec-num
          font-size 18px
          line-height 24px
          color #DAB693 !important
        .dec-num-1, .dec-num-2, .dec-num-3
          font-size 0 !important
          line-height 1
          &:before
            content ''
            background-image url('~pic/tabletop1.png')
            width 21px
            height 24px
            display inline-block
            background-size 100% 100%
        .dec-num-2
          &:before
            background-image url('~pic/tabletop2.png')
        .dec-num-3
          &:before
            background-image url('~pic/tabletop3.png')
      .ivu-table-tbody
        .ivu-table-row:nth-of-type(even)
          background-color rgba(128, 144, 201, 0.2) !important
#showImg img
  width: 100%
  display: block
</style>
